import * as React from "react";

export interface WrapperLinkProps {
    linkClassName?: string;
    href: string | undefined;
    target?: string;
}

const WrapperLink: React.FC<WrapperLinkProps> = ({ linkClassName, href, target, ...props }) => {
    if (href) {
        return (
            <a className={linkClassName} href={href} target={target}>
                {props.children}
            </a>
        );
    }

    return <>{props.children}</>;
};

export default WrapperLink;
